// 栏目管理 column
import http from '../request.js'

export default {
  // 获取列表
  getList: data => {
    return http({
      url: '/api/category/list_server',
      data
    })
  },

  // 获取详情
  getInfo: data => {
    return http({
      url: '/api/category/get',
      data
    })
  },

  // 新增
  add: data => {
    return http({
      url: '/api/category/add',
      data
    })
  },

  // 编辑
  edit: data => {
    return http({
      url: '/api/category/edit',
      data
    })
  },

  // 修改状态
  edit_status: data => {
    return http({
      url: '/api/category/edit_status',
      data
    })
  }
}
